<template>
  <div class="wrapper">
    <div class="btn" @click="push">前往茂南区河东街道社区卫生服务中心</div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods: {
    push(){
      window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIyNDQxMjEwNw==&scene=124#wechat_redirect"
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn{
    font-size: 18px;
    text-align: center;
    background: rgb(83, 192, 255);
    padding: 20px;
    // letter-spacing: 1px;
    border-radius: 4px;
    border: 1px solid #3eb8ff;
    color: #FFF;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/user/appointmentVaccines.vue